export default "__VITE_ASSET__Rqpv1lWM__"